import { render } from "./AirlinesElectricalDamage.vue?vue&type=template&id=4ca9db2d&scoped=true&ts=true"
import script from "./AirlinesElectricalDamage.vue?vue&type=script&lang=ts"
export * from "./AirlinesElectricalDamage.vue?vue&type=script&lang=ts"

import "./AirlinesElectricalDamage.vue?vue&type=style&index=0&id=4ca9db2d&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca9db2d"]])

export default __exports__